import { render, staticRenderFns } from "./infoSales.vue?vue&type=template&id=b30b668a&scoped=true"
import script from "./infoSales.vue?vue&type=script&lang=js"
export * from "./infoSales.vue?vue&type=script&lang=js"
import style0 from "./infoSales.vue?vue&type=style&index=0&id=b30b668a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30b668a",
  null
  
)

export default component.exports